import { render, staticRenderFns } from "./CourseCoordinators.vue?vue&type=template&id=7dcc86f4&"
import script from "./CourseCoordinators.vue?vue&type=script&lang=ts&"
export * from "./CourseCoordinators.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports